export const ADDRESS_FIELDS = ['add1', 'add2', 'add3', 'town', 'county', 'eircode'];

export const ADDRESS_LABELS = ['add1', 'add2', 'add3', 'town'];

export const CITY_EIRCODES = {
  Cork: ['T12', 'T23'],
  Galway: ['H91'],
  Limerick: ['V94'],
  Waterford: ['X91']
};

export const COUNTIES = [
  'Co. Carlow',
  'Co. Cavan',
  'Co. Clare',
  'Cork',
  'Co. Cork',
  'Co. Donegal',
  'Dublin 1',
  'Dublin 2',
  'Dublin 3',
  'Dublin 4',
  'Dublin 5',
  'Dublin 6',
  'Dublin 6W',
  'Dublin 7',
  'Dublin 8',
  'Dublin 9',
  'Dublin 10',
  'Dublin 11',
  'Dublin 12',
  'Dublin 13',
  'Dublin 14',
  'Dublin 15',
  'Dublin 16',
  'Dublin 17',
  'Dublin 18',
  'Dublin 20',
  'Dublin 22',
  'Dublin 24',
  'Co. Dublin',
  'Galway',
  'Co. Galway',
  'Co. Kerry',
  'Co. Kildare',
  'Co. Kilkenny',
  'Co. Laois',
  'Co. Leitrim',
  'Limerick',
  'Co. Limerick',
  'Co. Longford',
  'Co. Louth',
  'Co. Mayo',
  'Co. Meath',
  'Co. Monaghan',
  'Co. Offaly',
  'Co. Roscommon',
  'Co. Sligo',
  'Co. Tipperary',
  'Waterford',
  'Co. Waterford',
  'Co. Westmeath',
  'Co. Wexford',
  'Co. Wicklow'
];

export const COUNTY_LABELS = ['post_county', 'tertiary_locality', 'secondary_locality', 'primary_locality'];

export const RAW_ADDRESS_FIELDS = ['addr_line1', 'addr_line2', 'addr_line3', 'town', 'county', 'eircode'];

export const BROADBAND_COUNTIES = [
  'carlow', 'cavan', 'clare', 'cork', 'cork-city', 'donegal', 'dublin-1', 'dublin-2', 'dublin-3', 'dublin-4',
  'dublin-5', 'dublin-6', 'dublin-6w', 'dublin-7', 'dublin-8', 'dublin-9', 'dublin-10', 'dublin-11', 'dublin-12',
  'dublin-13', 'dublin-14', 'dublin-15', 'dublin-16', 'dublin-17', 'dublin-18', 'dublin-20', 'dublin-22', 'dublin-24',
  'dublin-county', 'galway', 'galway-city', 'kerry', 'kildare', 'kilkenny', 'laois', 'leitrim', 'limerick',
  'limerick-city', 'longford', 'louth', 'mayo', 'meath', 'monaghan', 'offaly', 'roscommon', 'sligo', 'tipperary',
  'waterford', 'waterford-city', 'westmeath', 'wexford', 'wicklow'
];
